import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['settings'] as const;

export const settingsQueryKeys = {
  base: baseKey,
  updateUserProfile: [...baseKey, 'updateUserProfile'],
} as const;
